'use client';

import { useEffect, useRef } from 'react';
import { useClickStream, EventType } from '@brahma/hooks';
import { usePathname } from 'next/navigation';
import useGlobalContext from '$applicant-portal/hooks/use-global-context';
import { PAGE_VIEW_NON_TRACKABLE_URLS } from './pageVisitDataCapture.constants';
export default function PageVisitDataCapture() {
  const {
    state
  } = useGlobalContext();
  const {
    trackEvent
  } = useClickStream('PageVisitDataCapture', state.user);
  const pathname = usePathname();
  const lastPathname = useRef<string | null>(null);
  useEffect(() => {
    if (!PAGE_VIEW_NON_TRACKABLE_URLS.some(nonTrackableUrl => pathname === nonTrackableUrl) && pathname !== lastPathname.current) {
      trackEvent({
        eventType: EventType.PAGE_VISIT,
        data: {}
      });
      lastPathname.current = pathname;
    }
  }, [pathname, trackEvent]);
  return null;
}